import MinimalModalBox from './MinimalModalBox'
import MinimalModalBoxTopIcon from './MinimalModalBoxTopIcon'

MinimalModalBox.TopIcon = MinimalModalBoxTopIcon

export default MinimalModalBox
